import Vue from 'vue';

Vue.component('order-layout', () =>
    import(/* webpackChunkName: 'order-layout' */ './order-layout.vue'),
);

Vue.component('order-layout-list', () =>
    import(/* webpackChunkName: 'order-layout-list' */ './order-layout-list.vue'),
);
